import { environment } from '@environments/environment';
import { LogService } from './../_services/log.service';
import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private logService: LogService) {
    super();
  }

  handleError(error: Error) {
    if (environment.production) this.logService.logException(error);
    throw error;
  }
}
